<template>
  <div>
    <list 
      row-key="CoopId" 
      ref="list" 
      unit="合作模式" 
      :page="page" 
      :query-params="params"
      :show-checkbox="$permission.canDel()" 
      :show-query="showQuery" 
      :get-data-func="api.list" 
      @reset="reset"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构">
          <tree-select
          ref="treeSelect"
          :props="props"
          :options="TreeData"
          :value="params.DpId"
          :clearable="true"
          :accordion="true"
          :parentSelect="true"
          placeholder="请选择"
          @node-select="onTreeSelect($event)"
        />
        </el-form-item>
        <el-form-item label="合作模式">
          <el-select v-model="params.CoopMode" placeholder="请选择状态" clearable>
            <el-option value="学员名额出库一次性收费"></el-option>
            <el-option value="学员名额出库收费+学时收费分成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="终止" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="归属机构" min-width="150" />
        <el-table-column prop="CoopMode" label="合作模式" min-width="120px" />
        <el-table-column prop="SignDate" label="签约时间" min-width="110">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.SignDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="StopDate" label="终止时间" min-width="110">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.StopDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="Status" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status == 1">正常</el-tag>
            <el-tag type="danger" v-else>终止</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ReviewStatus" label="审批状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.ReviewStatus==0">草稿</el-tag>
            <el-tag type="warning" v-else-if="row.ReviewStatus==1">待审批</el-tag>
            <el-tag type="danger" v-else-if="row.ReviewStatus==2">退回</el-tag>
            <el-tag type="success" v-else-if="row.ReviewStatus==3">已审批</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  // var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list, treeSelect },
    data() {
      return {
        api: require("@/api/op/coop").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          Name: "",
          LoginId: "",
          CoopMode: null,
          Status: null,
          DpId: null,
        },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
        TreeData: [],
      };
    },
    beforeMount() {
      this.dpApi.getAuthList({ DpTypes: [2,3,4], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
    },
    methods: {
      onTreeSelect(t) {
        if (!t) {
          this.params.DpId = null;
        } else {
          this.params.DpId = t.DpId;
        }
      },
      reset() {
        this.$refs.treeSelect.clearHandle();
      },
      delRange(Ids) {
        this.api.delete({ Ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>